export default {
  // Website metadata
  "index.title": "Flora 绿的专注力",
  "index.description":
    "Flora 是一个免费的效率 app，帮助你远离手机、清空待办事项、以及养成生活好习惯。每当你想更接近自己的目标时，就用 Flora 种树吧！",
  "index.social.title": "Flora 绿的专注力",
  "index.social.description": "轻松远离手机、清空待办事项、培养好习惯。",

  // components/Cta
  "Cta.appleStore": "在 App Store 取得",
  "Cta.googlePlay": "在 Google Play 取得",
  "Cta.chromeExt": "Chrome 扩充功能",

  // components/Share
  "Share.twitter": "超可爱的 app 帮助我放下手机并完成手边工作：\n",

  // route/NotFound
  "NotFound.pageTitle": "404 找不到网页",
  "NotFound.title": "404 找不到网页",
  "NotFound.text":
    "请求的网页不存在。请确定您所输入的网址是正确的，或前往我们的首页查询所需的内容。",
  "NotFound.button": "前往首页",

  // route/Home
  "Home.nav.features": "功能",
  "Home.nav.trees": "真树",
  "Home.nav.support": "支援",
  "Home.head.title": "绿的专注力",
  "Home.head.subtitle":
    "Flora 是一种全新的方法来帮助你远离手机、清空待办事项、以及养成积极正向的生活习惯。每当你想更接近自己的目标时，就用 Flora 种树吧<em>！</em>",
  "Home.leadModal.title": "即将登场...",
  "Home.leadModal.text":
    "此版本的 Flora 即将推出，敬请期待。如果你希望在它上线时收到通知，请在下方留下你的电子邮件地址：",
  "Home.leadModal.email": "输入电子邮件地址...",
  "Home.leadModal.error": "请提供正确的电子邮件地址",
  "Home.leadModal.close": "关闭",
  "Home.leadModal.submit": "上线时通知我",
  "Home.confirmModal.title": "谢谢",
  "Home.confirmModal.text": "我们会尽快与你联络。",
  "Home.confirmModal.close": "关闭",
  "Home.focus.title": "静心种树，远离干扰",
  "Home.focus.text":
    "就是无法放下手机？Flora 用轻松的方式阻挡令人分心的 app 例如 Facebook、Instagram 或游戏，并帮助你专注于现实生活中更重要的事情。",
  "Home.todo.1": "1. 选择想要专注多久时间，然后按 <ui>开始</ui> 种下一棵树。",
  "Home.todo.2": "2. 如果你离开 app 去用社交媒体或游戏，那这个棵树就会被杀死。",
  "Home.todo.3": "3. 成功保持专注并完成手边工作，即可发现新奇树种。",
  "Home.friends.title": "一起种树效率加倍",
  "Home.friends.text":
    "当你挑战朋友来「一起种树」时，事情将变得更加有趣且高效，因为如果你们一起成功远离手机，那么每个人都将额外赢得一棵树。你们也可以透过聊天或分享进度来为对方打气，并确保大家都保持前进。团队合作，梦想成真<em>！</em>",
  "Home.friends.original":
    "Flora 是「一起种树」的原创 app，并提供了最棒的功能来提升你与朋友们的工作效率。",
  "Home.todo.title": "更贴心的待办清单，让一切井井有条 <badge>新功能</badge>",
  "Home.todo.text":
    "Flora 是一个待办事项清单，而且包含进阶功能。简单输入待办事项并设置提醒，你就永远不会忘记任何事情。",
  "Home.todo.more":
    "更棒的是，您可以用待办事项标来记种过的树，以轻松追踪每个生活「目标」的达成进度。无论是每日、每周、或每月目标，Flora 都会帮助你坚持到底并实现它。",
  "Home.habit.title": "好习惯，就是这么简单",
  "Home.habit.text1":
    "享受充满回馈的日常好习惯。如果规律地种植树木，你将获得一座美丽且充满活力的「花园」。看看它，并为自己感到骄傲<em>！</em>这里的每棵树都记录了你的毅力和迈向健康生活的一小步。",
  "Home.habit.text2":
    "你还可以查看你在 Flora 中的每日、每周、或每月「活动统计」，以找到机会改善你的时间管理和规划技能。",
  "Home.realTree.title": "真正的树，真正的影响力",
  "Home.realTree.count": "棵真树由 Flora 使用者种植",
  "Home.realTree.text1":
    "何不在精进自我的同时种下真正的树？Flora 自豪地提供 Price 和 Care 服务，让你可以自由选择加入。只要启动这些服务，你即可在 app 中杀死或成功种植树木的同时，在地球上种下一棵「真正」的树苗。",
  "Home.realTree.text2":
    "我们与位于非洲以及东南亚的种树组织合作（例如 <a>Trees for the Future</a>）来种植那些会让土壤快速重新滋养的树木、具有高营养价值的果树、以及可以提供饲料和燃料木材的树种。这些树皆有助于绿化地球，并为那些最需要帮助的家庭提供长期经济援助。",
  "Home.rating.title": "全球超过 2 百万使用者",
  "Home.cta.title": "现在就取得 Flora。它是免费的！",
  "Home.footer.connect.title": "保持联系",
  "Home.footer.connect.text":
    "有问题吗？我们十分乐意提供帮助。请造访 <support>支援</support> 页面看看常见问题与解决方式，或发送电子邮件至 <email>support@flora.appfinca.com</email>，我们将尽快回覆。",
  "Home.footer.about.title": "我们致力于改变",
  "Home.footer.about.text":
    "Flora 是由 AppFinca Inc. 所开发。我们是一群年轻、热血的工程师以及环境爱好者，并且相信每个人都能透过使用更好的软体来改变世界。",
  "Home.footer.share": "分享 Flora 给朋友，来一起种树：",
  "Home.footer.legal":
    "<privacy>隐私政策</privacy> | <terms>服务条软</terms> | <ack>致谢</ack>",

  // route/Faq
  "Faq.pageTitle": "Flora 常见问题集",
  "Faq.title": "<primary>Flora</primary> 常见问题集",
  "Faq.text":
    "在这里，我们整理了一些常见问题的答案。如果你仍然找不到你的问题及回覆，欢迎透过 app 内的「意见回馈」功能（可以在 <ui>更多</ui> 画面上找到）或电子邮件 <a>support@flora.appfinca.com</a> 与我们联络。",
  "Faq.secFocusTrees.title": "专注功能",
  "Faq.selectSeed.q": "Q: 我一直种出一样的树。如何才能种出不同种类的植物呢？",
  "Faq.selectSeed.a":
    "<p>请在按 <ui>开始</ui> 按钮前，在主画面中点击 <ui>种子</ui> 图案。接下来你即可进入 <ui>伟大航道</ui> 画面并在不同的地点解锁不同种类的树。 祝您旅途愉快<em>！</em></p>",
  "Faq.offlinePlanting.q": "Q: 我可以在离线时种树吗？",
  "Faq.offlinePlanting.a":
    "<p>可以，Flora 支援 <ui>离线种植</ui> 模式。若要离线种植，请 <em>先</em> 断网再按 <ui>开始</ui> 按钮。 请注意，在离线种植模式中</p><ul><li>你的朋友将无法发现或加入你的空间以一起种树</li><li>如果树被杀死，你无法回报「错误侦测」</li></ul><p>因为没有网路连线。</p>",
  "Faq.notifiedAfterPlanting.q": "Q: 如何才能在树长大时收到通知？",
  "Faq.notifiedAfterPlanting.a":
    "<p>请确认你在 <ui>更多</ui> 画面中有允许 Flora 发送通知。如此一来，即使将手机锁上，你仍然会在树长大时收到一则通知讯息</p><p>另外，如果你手机的画面是保持在开启的状态，我们在种树成功时将不会送出通知讯息，因为你可以直接看到结果。</p>",
  "Faq.useOtherAppsWhilePlanting.q":
    "Q: 我可以在专注时使用其他工具 app（例如字典）而不杀死树吗？",
  "Faq.useOtherAppsWhilePlanting.a":
    "<p>可以。有两种方法可以在种树时使用其他 app：</p><ol><li>如果你只是偶尔需要使用其他 app，那么就在种树时按下 <ui>暂停</ui> 按钮。这样你就可以前往任何一个 app 而不杀死树。当使用完毕，回到 Flora 按下 <ui>继续</ui> 按钮即可继续种树。你暂停的时间会从最后的专注时间中扣除。请注意，暂停功能只有当你的树未设定「价格」时才能使用。如果你想要了解价格功能如何运作，请在主画面中的 <ui>价格</ui> 标签附近按下 <ui>?</ui> 图案了解详情。</li><li>如果你经常需要某些 app 来工作，请至 <ui>更多</ui> 画面中开启 <ui>专注时允许使用其他应用程式</ui> 选项，然后选择列入白名单的 apps。 在植树过程中，你可以离开 Flora 而不会杀死树木。但是你无法打开不在白名单中的应用程序。此功能仅适用于安装 iOS 16.1+ 的设备。</li></ol>",
  "Faq.finishEarlierWhilePlanting.q":
    "Q: 如果我在树长大之前就完成了手边任务怎么办？",
  "Faq.finishEarlierWhilePlanting.a":
    "<p>你只需按下 <ui>暂停</ui> 按钮，即可离开该 Flora 做任何你想做的事情。通过减去暂停时间，你的总专注时间将被正确地纪录下来。</p><p>请注意，暂停功能只有当你的树未设定「价格」时才能使用。如果你想要了解价格功能如何运作，请在主画面中的 <ui>价格</ui> 标签附近按下 <ui>?</ui> 图案了解详情。</p>",
  "Faq.finishLateWhilePlanting.q":
    "Q: 如果我在树长大之后还需要多点时间来完成任务怎么办？",
  "Faq.finishLateWhilePlanting.a":
    "<p>当树长大时，专注过程 <em>不会</em> 结束。所以尽管继续工作吧！在此期间，专注时长将自动往上累加以记录你的额外工作时间。完成工作后，你可以按 <ui>查看树</ui> 按钮结束专注过程并欣赏树。你的专注时长，包括树长大后的额外时间，将被正确地记录在对应故事中。</p>",
  "Faq.disablePause.q": "Q: 我可以关闭「暂停」功能吗？",
  "Faq.disablePause.a":
    "<p>可以。请至 <ui>更多</ui> 画面上关闭 <ui>专注时允许暂停</ui> 的选项，那么在种树过程中「暂停」功能就不会显示。</p><p>你也可以在种树前设定一个「价格」，这样暂停功能即会自动暂时关闭。请在主画面中的 <ui>价格</ui> 标签附近按下 <ui>?</ui> 图案来了解它是如何运作的。</p>",
  "Faq.backToWork.q": "Q: 我可以在种完树后调整「休息」计时器吗?",
  "Faq.backToWork.a":
    "<p>可以。当你成功种植一棵树后，可以按下绿色专注画面中的 <ui>计时器</ui> 图案 (位于 <ui>查看故事</ui> 按钮的左方)。这样你就可以调整「休息」计时器。它倒数完毕后会发送一则通知提醒你继续努力。</p>",
  "Faq.falseKill.q":
    "Q: 我并没有离开 Flora 可是我的树还是死了。接下来该怎么办？",
  "Faq.falseKill.a":
    "<p>如果你发现树被杀死了但觉得不是你的错，请借由按下红色专注画面右上方的 <ui>!</ui> (三角形惊叹号) 按钮来回报「错误侦测」。我们会在确认后帮你的树重生。如果我们发现了任何程式上的错误，我们将尽快修正它。同时，你可以尝试以下步骤让树被错杀的机率降至最低：</p><ul><li>在专注过程中如要锁上手机，请 <em>不要</em> 先按 Home 钮回到桌面。我们发现有些人有这个习惯，但这会杀死树。请放心地让 Flora 留在前景画面。</li><li>请更新您的 app 以及 iOS 至最新版。</li><li>请确保你有稳定的网路连线。如果你发现网路不稳或即将断线，请试着使用「离线种植」功能。</li><li>有时 iOS 会在某些情况下主动关闭 apps ，例如当记忆体不足、或是手机被锁上很久。当 Flora app 侦测到它被 iOS 自动关闭而再次被打开时，会试着恢复你的专注过程。尽管如此，由于 iOS 的限制，我们没有办法确保每次专注的状态都能被成功复原，请见谅。你可以尝试在种树前关闭留在背景却很吃记忆体的 apps (如游戏) 以降低 iOS 在种树过程中主动关闭 Flora 的机率。</li></ul>",
  "Faq.secGroupPlanting.title": "多人专注",
  "Faq.makeFriends.q": "Q: 如何在 Flora 里加朋友?",
  "Faq.makeFriends.a":
    "<p>请将显示在 <ui>朋友</ui> 画面中，你专属的「二维条码」分享给你的好友，或是扫描你朋友的二维条码。你也可以按下 <ui>朋友</ui> 画面中的 <ui>从联络人汇入</ui> 按钮来快速地与你联络人中的 Flora 使用者成为好友。</p>",
  "Faq.jointPlanting.q": "Q: 如何与朋友一起专注种树？",
  "Faq.jointPlanting.a":
    "<p>与朋友一起种树有两种方法：主持或是加入一个空间。</p><p>若要主持空间，请按主画面中的 <ui>人群</ui> 图案 (位于 <ui>开始</ui> 按钮的左边)，选择 <ui>朋友们</ui> 或是 <ui>选择的伙伴</ui> 选项。你也可以按主画面右上方的 <ui>钥匙</ui> 按钮以获取你这次种植的「通行码」并将其分享给你的朋友们。如此一来，在按下 <ui>开始</ui> 按钮后，你的朋友们即可发现并加入你的空间。</p><p>若要加入别人的空间，你可以到 <ui>朋友</ui> 画面中看看谁正在种树，或是向一位朋友取得通行码然后在主画面中按右上角的 <ui>钥匙</ui> 按钮输入它。接下来，你可以预览该空间 (例如看看还剩下多少时间) 来决定要不要加入。尽管是客人，你仍可在预览画面中按下 <ui>种子</ui> 图案选择自己想种的树。在按下 <ui>加入</ui> 按钮后，你即可与主持人一起种树。</p>",
  "Faq.killTreeWhileJointPlanting.q":
    "Q: 如果我在多人专注过程时离开 Flora，会发生什么事？",
  "Faq.killTreeWhileJointPlanting.a":
    "<p>如果你是空间主持人，那么 <em>每个人</em> 的树都会被你杀死，因为该空间将消失。另一方面，如果你是客人，那你只会杀死自己的树，而其他人将继续一起种植他们的树。</p>",
  "Faq.jointPlantingBenefits.q": "Q: 应该在什么时候与朋友一起种树？为什么？",
  "Faq.jointPlantingBenefits.a":
    "<p>与朋友或家人一起种树的时机包括：做功课、上课、学习讨论、会议、用餐、聊天、准时睡觉等。根据心理学专家 Festinger (1957)、Heider (1946) 以及 Newcomb (1953) 的研究指出，这不仅帮助你专注眼前的事务，更能够增进你们的 <em>长期</em> 工作效率，因为你对他们所做出的承诺将会帮助你的行为保持一致。此外，它还可以强化你们的友谊，因为那种共同完成一件事情的成就感会拉近彼此间的距离。</p><p>Flora 鼓励多人种树的方法就是让每位参与多人专注过程的使用者在成功之后 <em>额外</em> 赢得一棵由其他参与者所种的树。你准备好去赢取你朋友的树了吗？</p>",
  "Faq.secHabitTracker.title": "花园与故事",
  "Faq.totalFocusedTime.q": "Q: 在哪里可以看到我的总专注时间？",
  "Faq.totalFocusedTime.a":
    "<p>点击你在花园中的图像以进入 <ui>徽章</ui> 页面。那里会显示你的总专注时间，以及你距离下一个等级的徽章还有多远。</p>",
  "Faq.gardenLook.q": "Q: 如何让我的花园看起来更漂亮？",
  "Faq.gardenLook.a":
    "<p>在花园中，植物根据它们的种植日期排成一行，最近种植的在最右边。这样的设置让你可以完全控制花园的外观。要增强其美感，你可以在决定下一步种什么时考虑以下建议：</p><ul><li>避免连续种植树木。由于树与树之间的距离较远，这可能会让你的花园留下空白处。你可以在树之间种植一些花朵或水果，以创建更紧密、更生动的外观；</li><li>尝试混合颜色相似或互补的植物，以达到和谐的美感；</li><li>使用某些植物来纪念你生活中的特别事件。个人化你的花园，让它对你更加有意义和独特。</li></ul><p>但不要就此止步！让你的想像力尽情发挥，并将你的想法实现。祝你玩得愉快，同时也不要忘記与朋友们分享你创造的美丽成果！</p>",
  "Faq.gardenGap.q": "Q: 为什么我的花园里的植物右侧会有空白呢？",
  "Faq.gardenGap.a":
    "<p>你的花园中的树木会随着时间自然地向左移动。为了保持你的花园生机勃勃，定期种植新树木（并且专注于任务很重要，就如同你在真实世界照顾花园一般。你可以左右滑动花园，探索你过去所种的树木并查看你目前正在培育的真树。</p>",
  "Faq.bigGarden.q": "Q: 我可以一次看到我种的所有植物吗？",
  "Faq.bigGarden.a":
    "<p>可以。只需滑动花园到左侧的视图，你就可以看到你的 <ui>大花园</ui>。这里您可以一次欣赏你过去种的所有植物。请注意，大花园是 <ui>植树专家</ui> 的专属功能。如果你尚未达到该等级，别担心！持续你超凡的动力，朝那个徽章继续迈进。你将比你预期更快地享受到一览群树的喜悦。</p>",
  "Faq.noteStory.q": "Q: 我可以加一些笔记到我的树或故事吗？",
  "Faq.noteStory.a":
    "<p>没问题。在种树前，你可以在主画面中的 <ui>接下来要专注于什么呢？</ui> 区域填入你想要做的事。你也可以在种树后至 <ui>我的故事</ui> 页面，在对应故事里的 <ui>新增讯息...</ui> 区域中输入你已完成的事。</p>",
  "Faq.hideStory.q": "Q: 怎么避免我的一则故事被朋友们看到？",
  "Faq.hideStory.a":
    "<p>请按下该故事右上方的 <ui>⋮</ui> (烤肉串) 按钮，接下来你就可以调整该故事的能见度。如果选择 <ui>只限我</ui> 选项，该故事就只有你能够看得到。</p><p>但是请注意，该故事可能对你的朋友们来说有很大的激励作用，并可能引发有趣的互动。如果将故事隐藏，你将失去这些机会。</p>",
  "Faq.secTodoList.title": "待办事项、目标追踪、习惯打卡",
  "Faq.createTodo.q": "Q: 如何建立一个待办事项并设定提醒？",
  "Faq.createTodo.a":
    "<p>你可以从 <ui>花园</ui> 画面进入 <ui>提醒事项</ui> 页面，并按下任何一个 <ui>+</ui> (新增) 按钮来建立一个待办事项。如果你想在一周内的某个时间被提醒，请在该事项的选单中打开 <ui>提醒</ui> 功能。</p>",
  "Faq.goalTracking.q":
    "Q: 我可以为一个待办事项设定一个专注时间的目标并追踪它吗？",
  "Faq.goalTracking.a":
    "<p>可以。首先在该事项的选单中打开 <ui>目标</ui> 功能。你将看到一个「进度条」出现在该事项中。接下来，在专注过程中，你可以按下种树画面中的 <ui>标签</ui> 图示来把树标上一个待办事项。在树成功长大后，此次专注时间将会被自动累积到该事项的进度条中。你也可以至 <ui>我的故事</ui> 页面为你的故事们标记不同事项来累积进度。</p>",
  "Faq.resetGoal.q": "Q: 我可以建立自动重复的目标吗？",
  "Faq.resetGoal.a":
    "<p>没问题。请开启一个待办事项的选单，在 <ui>目标</ui> 的地方选择 <ui>每日</ui>、<ui>每周</ui>、或 <ui>每月</ui> 重置目标进度。</p>",
  "Faq.habitTracker.q": "Q: 如何帮我的好习惯打卡？",
  "Faq.habitTracker.a":
    "<p>在一个待办事项的选单中，你可以开启 <ui>习惯打卡</ui> 来追踪你与该事项相关的活动。然后，如果你连续几天成功种树并标上该事项，那么你将看到代表「连胜」的横线。</p><p>Flora 也会将你的专注活动汇总为每日、每周、每月、和每年的详细统计图表，帮助你找到机会改善自己的时间管理和规划技能。你可以在 <ui>花园</ui> 画面中的 <ui>统计资料</ui> 页面中看到这些图表。</p>",
  "Faq.secPayment.title": "付款相关",
  "Faq.whatRealTrees.q": "Q: 你们的真树都种在哪里？种哪些树？",
  "Faq.whatRealTrees.a":
    "<p>我们与在非洲以及东南亚工作的种树组织合作（例如 <a>Trees for the Future</a> 以及 <a2>Eden Reforestation Projects</a2>）来种植那些会让土壤快速重新滋养的树木、具有高营养价值的果树、以及可以提供饲料和燃料木材的树种。这些树皆有助于绿化地球，并为那些最需要帮助的家庭提供长期经济援助。</p>",
  "Faq.priceCharge.q":
    "Q: 我种树设定了「价格」可是 app 后来却错误地杀死了树。可以要求退款吗？",
  "Faq.priceCharge.a":
    "<p>当使用「价格」功能时，除非你按下红色专注画面中的 <ui>履行承诺的价格</ui> 按钮，否则你是 <em>不会</em> 被收取任何费用的。如果你发现树被错杀，请按红色专注画面中的 <ui>!</ui> (三角形惊叹号) 按钮来回报「错误侦测」。如果你已经按过 <ui>履行承诺的价格</ui> 按钮而想要退款，请透过电子邮件描述你所遭遇的情况并寄至 <a>support@flora.appfinca.com</a> 。我们会尽快提供必要的协助。</p>",
  "Faq.errorCode.q": "Q: 我在付款时得到了一组「错误码」，请问该怎么办？",
  "Faq.errorCode.a":
    "<p>请将该错误码寄到 <a>support@flora.appfinca.com</a> 并简单描述你的使用过程。我们会在那里提供必要的协助。</p>",
  "Faq.receipt.q": "Q: 我可以拿到付款的收据吗？",
  "Faq.receipt.a":
    "<p>当然。 请将你的「帐号名称」、「帐号邮件地址」、与「购买日期与时间」寄到 <a>support@flora.appfinca.com</a>，我们会回寄付款收据。</p>",
  "Faq.secMisc.title": "其他",
  "Faq.restoreIap.q":
    "Q: 我之前买的旅程 (像是「亚马逊雨林」) 不见了。该怎么办？",
  "Faq.restoreIap.a":
    "<p>请至 <ui>更多</ui> 画面中，按下 <ui>复原应用程式内购买</ui> 按钮。这样你所购买过的旅程就会重新出现。</p>",
  "Faq.dataInCloud.q": "Q: Flora 是否会将我的数据存在云中？",
  "Faq.dataInCloud.a":
    "<p>尽管你大部分的数据（包括旅程进度、花园、待办事项、故事）都保存在云中，但 Flora 目前不会在我们的伺服器上存储你的<ui>统计资料</ui>。 这意味着：<em>如果重新安装 app，你将会失去你的统计资料。</em> 在未来，我们会扩充服务器以储存所有内容。</p>",
  "Faq.energyConsumption.q": "Q: Flora 有多耗电？",
  "Faq.energyConsumption.a":
    "<p>尽管 Flora 使用了一个精密的演算法来正确地侦测你是否在专注的过程中离开 app，我们在设计侦测机制时考虑了耗电量。根据我们的测试结果，Flora 并没有比一个普通的音乐播放器还要耗电。</p>",
  "Faq.florVsForest.q": "Q: Flora 与 Forest 还是合作伙伴吗？",
  "Faq.florVsForest.a":
    "<p>不再是了。也许你已经知道，我们团队与 Forest 团队是来自清华大学的同一个实验室。在实验室时，大家决议 Forest 主打「单人种树」而 Flora 主打「多人种树」功能。 Flora 于 2017 年 8 月上线，两个 app 原始的设计是互补的。然而，在 Flora 获得不错的回响之后， Forest 团队在 2018 年 2 月推出了一模一样的多人种树功能。自此之后，两个 app 的合作关系即终止并且各自演化成为独立的产品。如果您想与朋友享受一起种树、一起努力的成就感，请选择并支持原创的 Flora。</p>",
  "Faq.floraPaidVersion.q": "Q: Flora 有 “付费版” 吗？",
  "Faq.floraPaidVersion.a":
    "<p>没有。我们只提供单一、免费的 Flora 版本。Flora 是「一起种树」的原创 app，任何复制此功能（甚至对其收取费用）的其他应用程序均与我们无关。如果你喜欢享受与朋有们一起达成目标的成就感，请选择并支持原创的 Flora。</p>",
  "Faq.end":
    "如果您有尚未被回答的问题，请透过 app 内的「意见回馈」系统或是邮件信箱 <a>support@flora.appfinca.com</a> 与我们联络。",
  "Faq.secWidget.title": "小组件 (仅限 iOS 14+)",
  "Faq.widgetEmpty.q": "Q: 我的小组件里什么也没显示。该怎么办？",
  "Faq.widgetEmpty.a":
    "<p>小组件大约每 30 分钟会与主 app 同步一次。所以，请给它一些时间。如果你等了很长的时间后却仍然没有看见任何内容，请</p><ol><li>将 Flora app 更新到最新版本</li><li>打开 app 并前往你的 <ui>花园</ui> (必要步骤)</li><li>回到 <ui>主屏幕</ui> 或 <ui>锁定画面</ui> 将小组件移除，并重新加入</li></ol><p>小组件的内容应在接下来的 30 分钟内显示。如果问题仍然持续，请通过 app 内的反馈系统与我们联系。我们将协助您解决问题。</p>",

  // route/news/year-end-report-2020
  "ImpactReport2020.pageTitle": "Flora 影响力报告",
  "ImpactReport2020.app.topic": "新鲜事",
  "ImpactReport2020.app.title": "看看我们一起在 2020 年产生的影响力",
  "ImpactReport2020.title": "<primary>Flora</primary> 影响力报告, 2020",
  "ImpactReport2020.subtitle": "一趟有您参与的美好旅程。",
  "ImpactReport2020.greet":
    "致所有亲爱的 Flora 使用者：新年快乐<em>！</em> 我们由衷地感谢您支持 Flora app，并帮助那些与我们合作的农村社群，使它们在逆境中仍然保持韧性。 去年对农村社群来说是个充满挑战的一年。 但多亏您的支持，参与合作项目的农民们能够种植真树，并生产出他们所需的东西以改善家庭状况、绿化地球。",
  "ImpactReport2020.today":
    "今天，我们很高兴分享一些统计数据，回顾过去几年我们共同对环境所做出的改变。身为 Flora app 的开发者以及环境爱好者，这对我们来说是值得纪念的一步。",
  "ImpactReport2020.stats.trees": "棵真树种植",
  "ImpactReport2020.stats.farmland": "英亩耕地恢复",
  "ImpactReport2020.stats.people": "人获得帮助",
  "ImpactReport2020.stats.text":
    "透过 Flora Price 以及 Care 服务，Flora 使用者已在全球种植了 50,927 棵真树。该种植任务由我们在肯亚、塞内加尔、坦桑尼亚、及乌干达的 1,523 多位农村合作伙伴完成。期间我们也协助复育了约 170 英亩的耕地。",
  "ImpactReport2020.npo":
    "我们通过资助一些国际非营利组织（例如 <a>Trees for the Future</a>）所发起的「常青职训」计划来支持农民。这些组织对那些长年生活在贫困中的农民进行为期多年的培训。在此期间，农民学到了如何在不用有害且昂贵的化学农药的情况下来保护土地、多样化作物。等到计划结束时，该农村家庭将会获得可靠的收入来源，并获得充足、有营养的食物，免除饥饿。",
  "ImpactReport2020.life":
    "您持续使用 Flora app 的好习惯，已转化为对地球以及那些脆弱、急需援助的社区的持久帮助。许多人的生活因此永远改变了，永远。",
  "ImpactReport2020.farmer.salma.quote":
    "我学会了许多宝贵的知识，包含如何保护耕地、正确种植苗木、间作、以及诸如小巷种植和等高线种植等土地翻新技术。",
  "ImpactReport2020.farmer.salma": "— Salma Mussa, 一位坦桑尼亚农民",
  "ImpactReport2020.farmer.nangira.quote":
    "我花园里的作物大大改善了我的家庭状况。它们不仅提供食物，还让我可以在市场上卖一些。常青职训计划 … 是社区、也是我的计划。",
  "ImpactReport2020.farmer.nangira": "— Francis Adupa 来自乌干达的 Kole 区",
  "ImpactReport2020.trees":
    "我们协力种植的真树将在未来几年内继续为这些农民们提供食物及资源。同时，借由恢复生态多样性、将水引入地下、肥沃土壤以及存碳，这些树也正逐渐恢复我们的环境。",
  "ImpactReport2020.proud":
    "如果没有 Flora 使用者们的辛勤工作和决心，上述的所有事情都是不可能完成的。我们为你感到十分骄傲。",
  "ImpactReport2020.2021": "展望 2021",
  "ImpactReport2020.grow":
    "多亏了超棒的支持者们，我们在过去两年中以每年 50％ 的平均速度增长。这意味着我们可以用更快的速度种植真树、并帮助更多的家庭。",
  "ImpactReport2020.cta":
    "但是，由于气候变化和 COVID-19 疫情的影响，我们的任务也变得越来越艰钜。如果您想持续做出改变、与我们并肩走在改变世界与终止饥饿的道路上，那么仅需要在专注时启用 <ui>Price</ui> 或是订阅我们的 <ui>Care</ui> 服务。",
  "ImpactReport2020.conclude":
    "再次感谢您。让我们保持前进，一起创造充实的 2021<em>！</em>",

  // route/news/ImpactReport2021
  "ImpactReport2021.pageTitle": "Flora 影响力报告",
  "ImpactReport2021.app.topic": "新鲜事",
  "ImpactReport2021.app.title": "看看我们一起在 2021 年产生的影响力",
  "ImpactReport2021.title": "<primary>Flora</primary> 影响力报告, 2021",
  "ImpactReport2021.subtitle": "一趟有您参与的美好旅程。",
  "ImpactReport2021.greet1":
    "新年快乐<em>！</em> 每年，我们都被用户的热情所震撼。 去年也不例外，多亏有你。",
  "ImpactReport2021.greet2":
    "2021 年的你很努力。而且你证明了：那些小事，例如一分钟的专注、一棵花园里的小树、一个待办事项的完成，真的可以累积成巨大效益。 通过 Flora <ui>Price</ui> 和 <ui>Care</ui> 服务，你的努力还支持了我们合作农村社区的真树种植，从而创造就业机会、保护生态系统、和帮助减缓气候变化。",
  "ImpactReport2021.stats.trees": "棵真树种植",
  "ImpactReport2021.stats.farmland": "英亩耕地恢复",
  "ImpactReport2021.stats.people": "人获得帮助",
  "ImpactReport2021.stats.text":
    "Flora 使用者已合力在全球种植了 76,391 棵真树。该种植任务由我们在马里、查德、喀麦隆、中非共和国、肯尼亚、乌干达、和坦桑尼亚的 3,808 多位农村合作伙伴完成。期间我们也协助复育了约 250 英亩的耕地。",
  "ImpactReport2021.stats.dig": "让我们挖掘这些惊奇数字背后的一些细节。",
  "ImpactReport2021.subtitle.partner": "新伙伴",
  "ImpactReport2021.partner.announce":
    "今天，我们很高兴地宣布：位于美国加州的非营利组织 <a>Eden Reforestation Projects</a> 成为了我们新的合作伙伴。 这丰富了我们的农村社区，同时强化了我们对减少贫困和恢复健康森林的承诺。",
  "ImpactReport2021.partner.trees":
    "在我们种植的 76,391 棵真树中，超过 31,000 棵是由 Eden Reforestation Projects 完成的。Eden 在全球雇佣了上万的人来种植真树。通过该合作，Flora 用户已经提供了必要的工作、工具、和教育给位于以下新国家的家庭：",
  "ImpactReport2021.partner.country1": "<ui>马达加斯加</ui>",
  "ImpactReport2021.partner.country2": "<ui>印度尼西亚</ui>",
  "ImpactReport2021.partner.country3": "<ui>尼泊尔</ui>",
  "ImpactReport2021.partner.country4": "<ui>莫桑比克</ui>",
  "ImpactReport2021.partner.country5": "<ui>海地</ui>",
  "ImpactReport2021.partner.country6": "<ui>洪都拉斯</ui>",
  "ImpactReport2021.partner.country7": "<ui>尼加拉瓜</ui>",
  "ImpactReport2021.partner.country8": "<ui>巴西</ui>",
  "ImpactReport2021.subtitle.project": "我们帮助过的人",
  "ImpactReport2021.project.npo":
    "我们通过资助一些「常青职训」计划来支持农民。这些组织对那些长年生活在贫困中的农民进行为期多年的培训。在此期间，农民学到了如何在不用有害且昂贵的化学农药的情况下来保护土地、多样化作物。等到计划结束时，该农村家庭将会获得可靠的收入来源，并获得充足、有营养的食物，免除饥饿。",
  "ImpactReport2021.project.life":
    "您持续使用 Flora app 的好习惯，已转化为对地球以及那些脆弱、急需援助的社区的持久帮助。许多人的生活因此永远改变了，永远。",
  "ImpactReport2021.project.farmer1.quote":
    "我很感激他们传授的知识，使我的农地产出更高的经济价值... 养活我的五个孩子和九口之家。",
  "ImpactReport2021.project.farmer1": "— Waneloba Loy，来自乌干达的一位老师",
  "ImpactReport2021.project.farmer2.quote":
    "现在我有一些东西可以吃和卖，好在旱季养家糊口。我由衷觉得这是维持家人幸福的唯一机会。",
  "ImpactReport2021.project.farmer2": "— 来自坦桑尼亚的 Hamis Ramadhani",
  "ImpactReport2021.project.trees":
    "我们协力种植的真树将在未来几年内继续为这些农民们提供食物及资源。同时，借由恢复生态多样性、将水引入地下、肥沃土壤以及存碳，这些树也正逐渐恢复我们的环境。",
  "ImpactReport2021.project.proud":
    "如果没有 Flora 使用者们的辛勤工作和决心，上述的所有事情都是不可能完成的。我们为你感到十分骄傲。",
  "ImpactReport2021.subtitle.outlook": "展望 2022",
  "ImpactReport2021.outlook.growth":
    "身为 Flora 开发者，我们将继续我们的使命：在改进 Flora 应用程序的同时创造一个更好的居住环境。多亏了像你一样的超棒支持者们，我们在过去两年中以每年 50％ 的平均速度增长。这意味着我们可以用更快的速度种植真树、并惠及更多的家庭。",
  "ImpactReport2021.outlook.cta":
    "然而，由于气候变化和 COVID-19 疫情的影响，我们的任务也变得越来越艰钜。如果您想持续做出改变、与我们并肩走在改变世界与终止饥饿的道路上，那么仅需要在专注时启用 <ui>Price</ui> 或是订阅我们的 <ui>Care</ui> 服务。",
  "ImpactReport2021.outlook.conclude":
    "再次感谢您。让我们保持前进，一起创造充实的 2022<em>！</em>",

  // route/news/ImpactReport2022
  "ImpactReport2022.pageTitle": "Flora 影响力报告",
  "ImpactReport2022.app.topic": "新鲜事",
  "ImpactReport2022.app.title": "看看我们一起产生的影响力",
  "ImpactReport2022.title": "<primary>Flora</primary> 影响力报告",
  "ImpactReport2022.subtitle": "一趟有您参与的美好旅程。",
  "ImpactReport2022.greet1":
    "每天，我们都被用户的热情所震撼。人们使用 Flora 时很认真，而你证明了：那些小事，例如一分钟的专注、一棵花园里的小树、一个待办事项的完成，真的可以累积成巨大效益。",
  "ImpactReport2022.greet2":
    "通过 Flora 提供的选择性 <ui>Price</ui> 和 <ui>Care</ui> 服务，你的努力还支持了我们合作农村社区的真树种植，从而创造就业机会、保护生态系统、和帮助减缓气候变化。",
  "ImpactReport2022.stats.trees": "棵真树种植",
  "ImpactReport2022.stats.farmland": "英亩耕地恢复",
  "ImpactReport2022.stats.people": "人获得帮助",
  "ImpactReport2022.stats.text":
    "Flora 使用者已合力在全球种植了 86,734 棵真树。该种植任务由我们在马里、查德、喀麦隆、中非共和国、肯尼亚、乌干达、和坦尚尼亚的 4,675 多位农村合作伙伴完成。期间我们也协助复育了约 350 英亩的耕地。",
  "ImpactReport2022.stats.dig": "让我们挖掘这些惊奇数字背后的一些细节。",
  "ImpactReport2022.subtitle.partner": "新伙伴",
  "ImpactReport2022.partner.announce":
    "今天，我们很高兴地宣布：位于美国加州的非营利组织 <a>Eden Reforestation Projects</a> 成为了我们新的合作伙伴。 这丰富了我们的农村社区，同时强化了我们对减少贫困和恢复健康森林的承诺。",
  "ImpactReport2022.partner.trees":
    "在我们种植的 86,734 棵真树中，超过 31,000 棵是由 Eden Reforestation Projects 完成的。Eden 在全球雇佣了上万的人来种植真树。通过该合作，Flora 用户已经提供了必要的工作、工具、和教育给位于以下新国家的家庭：",
  "ImpactReport2022.partner.country1": "<ui>马达加斯加</ui>",
  "ImpactReport2022.partner.country2": "<ui>印度尼西亚</ui>",
  "ImpactReport2022.partner.country3": "<ui>尼泊尔</ui>",
  "ImpactReport2022.partner.country4": "<ui>莫三比克</ui>",
  "ImpactReport2022.partner.country5": "<ui>海地</ui>",
  "ImpactReport2022.partner.country6": "<ui>洪都拉斯</ui>",
  "ImpactReport2022.partner.country7": "<ui>尼加拉瓜</ui>",
  "ImpactReport2022.partner.country8": "<ui>巴西</ui>",
  "ImpactReport2022.subtitle.project": "我们帮助过的人",
  "ImpactReport2022.project.npo":
    "我们通过资助一些“常青职训”计划来支持农民。这些组织对那些长年生活在贫困中的农民进行为期多年的培训。在此期间，农民学到了如何在不用有害且昂贵的化学农药的情况下来保护土地、多样化作物。等到计划结束时，该农村家庭将会获得可靠的收入来源，并获得充足、有营养的食物，免除饥饿。",
  "ImpactReport2022.project.life":
    "您持续使用 Flora app 的好习惯，已转化为对地球以及那些脆弱、急需援助的社区的持久帮助。许多人的生活因此永远改变了，永远。",
  "ImpactReport2022.project.farmer1.quote":
    "我很感激他们传授的知识，使我的农地产出更高的经济价值... 养活我的五个孩子和九口之家。",
  "ImpactReport2022.project.farmer1": "— Waneloba Loy，来自乌干达的一位老师",
  "ImpactReport2022.project.farmer2.quote":
    "现在我有一些东西可以吃和卖，好在旱季养家糊口。我由衷觉得这是维持家人幸福的唯一机会。",
  "ImpactReport2022.project.farmer2": "— 来自坦桑尼亚的 Hamis Ramadhani",
  "ImpactReport2022.project.trees":
    "我们协力种植的真树将在未来几年内继续为这些农民们提供食物及资源。同时，借由恢复生态多样性、将水引入地下、肥沃土壤以及存碳，这些树也正逐渐恢复我们的环境。",
  "ImpactReport2022.project.proud":
    "如果没有 Flora 使用者们的辛勤工作和决心，上述的所有事情都是不可能完成的。我们为你感到十分骄傲。",
  "ImpactReport2022.subtitle.outlook": "展望未来",
  "ImpactReport2022.outlook.growth":
    "身为 Flora 开发者，我们将继续我们的使命：在改进 Flora 应用程序的同时创造一个更好的居住环境。多亏了像你一样的超棒支持者们，我们在过去两年中以每年 50％ 的平均速度增长。这意味着我们可以用更快的速度种植真树、并惠及更多的家庭。",
  "ImpactReport2022.outlook.cta":
    "然而，由于气候变化和 COVID-19 疫情的影响，我们的任务也变得越来越艰钜。如果您想持续做出改变、与我们并肩走在改变世界与终止饥饿的道路上，那么仅需要在专注时启用 <ui>Price</ui> 或是订阅我们的 <ui>Care</ui> 服务。",
  "ImpactReport2022.outlook.conclude":
    "再次感谢您。让我们保持前进，一起创造充实的每一天<em>！</em>",

  // route/tips/Widget
  "Widget.pageTitle": "Flora 小组件",
  "Widget.app.topic": "小技巧",
  "Widget.app.title": "不间断的激励，来自 Flora 小组件",
  "Widget.title": "<primary>Flora</primary> 小组件",
  "Widget.subtitle": "来自桌面以及锁定画面的生产力。",
  "Widget.greet":
    "您是否经常忘记种树或是待办事项？别担心。为桌面或锁定画面注入一点生机，好让你无时无刻都受到提醒和激励。",
  "Widget.header.addWidget": "新增小组件",
  "Widget.steps":
    "有了 iOS 16 或以上版本，你可以在桌面或锁定画面上新增 Flora 小组件。只要以下 3 个简单步骤：",
  "Widget.step1": "长按 <ui>桌面</ui> 或 <ui>锁定画面</ui>，然后开启小组件选单",
  "Widget.step2": "往下滑动，点选 <ui>Flora</ui>",
  "Widget.step3":
    "在不同尺寸的小组件中，选择最符合你需要的一种，然后按 <ui>加入小组件</ui>",
  "Widget.added":
    "瞧<em>！</em>你把主屏幕变成了一个美丽的花园。Flora 小组件将定期与主 app 同步以显示你所种过的树。同步大约每隔 30 分钟发生一次。因此，你可能需要等一段时间才能看到内容。",
  "Widget.header.benefits": "不间断的提醒与动力",
  "Widget.trees":
    "与主 app 一样，Flora 小组件中的每棵树仅持续 7 天。这意味着你必须规律地种树以确保小组件里充满生命。每当在主屏幕的树变得越来越少时，你就知道应该再种一棵新树，并开始工作了。",
  "Widget.todos":
    "如果你选择了大尺寸的 Flora 小组件，它还会显示你的待办事项，并自动把即将来临的任务置顶。你再也不会忘记重要的事了，因为它们就座落在你的主屏幕上。此外，每个待办事项还会显示完成进度，提醒你距离目标还有多远。",
  "Widget.cta":
    "有了 Flora 小组件，你可以将工作效率提升到一个全新的境界。试试看，并通过 app 内的回馈系统告诉我们你的想法。",

  // route/tips/AppWhitelist
  "AppWhitelist.pageTitle": "App 白名单",
  "AppWhitelist.app.topic": "小技巧",
  "AppWhitelist.app.title": "使用 App 白名单发挥潜能",
  "AppWhitelist.title": "使用 App 白名单发挥潜能",
  "AppWhitelist.subtitle": "专注力，由你自己定义",
  "AppWhitelist.greet1":
    "如你所知，Flora 借由在种树时阻挡其他 app 来提高你的专注力并避免分心。但是，我们理解有些用户需要使用一些特定的 app，例如计算机或词典，才能有效地完成工作。因此，我们开发了一个 <em>白名单</em> 功能，让你能够在专注过程中使用一些应用程序而不会杀死你的树木。",
  "AppWhitelist.header.how": "如何使用",
  "AppWhitelist.stepStart":
    "要使用此新功能，请将 iOS 更新至版本 16.1+ 以及 Flora 至版本 3.5+。然后，打开 Flora，按照以下步骤操作：",
  "AppWhitelist.step1":
    "进入<ui>更多</ui>标签，打开<ui>专注时程允许使用其他应用程式</ui>选项。",
  "AppWhitelist.step2": "允许 Flora 存取你的荧幕时间。",
  "AppWhitelist.step3":
    "点击下方的<ui>允许所有应用程式</ui>选项。然后选择你在专注过程中想要使用的应用程序。",
  "AppWhitelist.stepEnd":
    "现在，当你种树时，如果你尝试打开不在白名单中的应用程序，你会看到一个提示画面，告诉你返回 iOS 桌面。这提醒你 Flora 正在帮助你保持专注，并远离任何可能引你偏离目标的干扰。",
  "AppWhitelist.header.feedback": "与我们分享你的意见",
  "AppWhitelist.feedback1":
    "我们很高兴能为 Flora 的使用者提供这项新功能。我们的目标是帮助你发挥潜能、实现梦想，而我们相信这个白名单功能带我们往这个目标更迈进了一步。我们希望你能使用它来定义你的专注过程以符合个人需求，并充分利用有 Flora 陪伴的时间。",
  "AppWhitelist.feedback2":
    "我们希望能不断支持你的旅程。如果你有任何问题或反馈，请随时与我们联系。我们十分乐于听到你的意见并不断改进我们的 app 以满足你的需求。让我们一起种树，一步一个任务来培养专注力。加油吧<em>!</em>",
  "AppWhitelist.faq.when.q": "Q: 什么时候应该启用 app 白名单功能？",
  "AppWhitelist.faq.when.a":
    "<p>对于许多用户来说，Flora 的预设的 app 阻止功能已经足够帮助他们在现今的数位时代保持专注，因为手机是绝大多分心的事物的来源。但是，如果你需要使用某些 app 来完成你的任务，请考虑启用白名单功能。</p>",
  "AppWhitelist.faq.treeKilled.q":
    "Q: 白名单功能可以让我的树在专注过程中永远不会死吗？",
  "AppWhitelist.faq.treeKilled.a":
    "<p>不能。启用白名单功能后，如果你试图取消一个正在进行的专注过程，例如终止 Flora 应用程式，那么你仍然会杀死一棵树。因此，你仍然需要将你所承诺的专注时间放在心上，才能成功地种出一棵健康的树。</p>",

  // route/tips/AutoStopwatch
  "AutoStopwatch.pageTitle": "自动正计时",
  "AutoStopwatch.app.topic": "小技巧",
  "AutoStopwatch.app.title": "用自动正计时纪录每分每秒",
  "AutoStopwatch.title": "用自动正计时纪录每分每秒",
  "AutoStopwatch.subtitle": "更精确的时间追踪，更高的工作效率",
  "AutoStopwatch.greet1":
    "以下情境可能会让人感到沮丧：为某个任务设定专注计时器，然后花了比原本预期还久的时间完成工作，最终却发现仅有一开始在计时器中所设定的时间被记录在统计资料和故事中。有了 Flora 的新 <em>自动正计时</em> 功能，你现在可以记录你花在任务上的额外时间，以更准确地反应你的生产力。",
  "AutoStopwatch.header.how": "如何使用",
  "AutoStopwatch.step1":
    "首先，请升级你的 Flora 应用程序至 3.5 版或更高版本。然后在种树时就可以享受这个功能。",
  "AutoStopwatch.step2":
    "在开始专注计时后，你会看到一个<ui>专注时长指示器</ui> <icon1></icon1>。当计时器倒数结束后，这个指示器会开始往上计时 (见 <icon2></icon2>)，而 Flora 不会立即停止此专注过程。相反地，它会让指示器累积你在任务上花费的额外时间，即便倒数计时已经停止。",
  "AutoStopwatch.step3":
    "专注过程仅会在你按下<ui>查看树</ui> <icon3></icon3> 按钮时才会结束。Flora 会把总专注时间，包括你花在原本计时器之外的时间，记录下来。这样，你就不会觉得这些额外时间不见了，并且准确地追踪你的生产力。",
  "AutoStopwatch.step4":
    "我们相信，一旦你知道你花在任务上的所有时间都将被准确记录，你将更有动力去保持专注。此外，这也是一种挑战自己在休息之前完成工作的好方式。",
  "AutoStopwatch.header.feedback": "与我们分享你的意见",
  "AutoStopwatch.feedback1":
    "我们要感谢大家提供回馈意见，使得我们能够推出这个功能。希望你会喜欢它，就如同我们在为你开发它时一样。继续种树，完成你的待办事项，并且不要忘记透过 app 内的回馈系统持续与我们分享你的想法。我们很乐意聆听你的意见，并让 Flora 更贴近你的需求。",
  "AutoStopwatch.faq.pause.q": "Q: 如果我比预期的时间更早完成了工作怎么办？",
  "AutoStopwatch.faq.pause.a":
    "<p>如果你在专注计时器倒数结束之前完成了一个任务，只需点击<ui>暂停</ui>按钮，然后你就可以休息一下并视需要切换到其他应用程式。计时器结束时，你将收到一则通知，提醒你返回 Flora 并查看你的树。在专注时长指示器开始累加额外时间之前，暂停时间将会从专注时长中先行扣除。通过自动正计时和暂停功能的协力工作，无论发生什么情况，你都能准确量测你的日常生产力。</p>",

  // route/tips/StyliseGarden
  "StylizeGarden.pageTitle": "你的花园，你的风格",
  "StylizeGarden.title": "你的花园，你的风格",
  "StylizeGarden.app.topic": "更新",
  "StylizeGarden.app.title": "你的花园，你的风格",
  "StylizeGarden.subtitle": "独特、难以置信、同时又充满奖励",
  "StylizeGarden.greetings":
    "给热血的 Flora 爱用者： 我们知道你一直在努力地添加绿意与花朵到你的花园。长久以来，植物们绽放在自动且不可预测的排列之中。然而，我们不断地收到反馈，希望能对花园有更多控制，以挥洒创意。",
  "StylizeGarden.announcement":
    "我们很高兴宣布一项更新：一个全新、线性的 <ui>花园</ui> 视图，归还那把整理植物的剪刀到你的手中，让你自由塑造你专属的花园外观。",
  "StylizeGarden.header.features": "新功能",
  "StylizeGarden.features":
    "在新的花园中，你的植物将排列成整齐的一列，其中最新添加的植物位于右侧醒目位置。随着时间的推移，您的植物将向左移动，为新生命腾出空间。你可以把它看作是一个温柔的提醒：一个充满活力的花园需要定期的照护和新成员的加入。这将激励你持续保持专注以积极处理你的任务。",
  "StylizeGarden.header.beautify": "美化你的花园",
  "StylizeGarden.beautify.start":
    "现在，每当开始专注时，你将面临一个愉快的小挑战：那就是决定下一个植物是什么。以下有一些提示，帮助你打造一个不仅茂密而且独特的花园：",
  "StylizeGarden.beautify.1":
    "<em>多样化树种</em>：避免连续种植“树木”。由于树木之间的间隔较远，它们会在你的花园中留下空白。相反地，尝试交互运用花朵或水果这类植物，以创造出更加繁密、更茂盛的外观。",
  "StylizeGarden.beautify.2":
    "<em>色彩协调</em>：通过混合具有相似或互补颜色的植物来调色你的花园。这可以创建一个令人赏心悦目的视觉空间。",
  "StylizeGarden.beautify.3":
    "<em>个人密码</em>：用某些特殊的植物来纪念你生活中的里程碑或事件，这将赋予一层新的意义到你的绿色数位花园。",
  "StylizeGarden.beautify.end":
    "但不要让这些建议限制你的创造力！花园是你想像力的画布，把想法实现，并与朋友分享你打造的独特花园。绿手指们总是会互相激励。",
  "StylizeGarden.header.bigGarden": "植树专家的大花园",
  "StylizeGarden.bigGarden":
    "对于那些已经赢得 <ui>植树专家</ui> 徽章的勤奋使用者们，我们还提供了 <ui>大花园</ui> 这项新功能。在这里，你可以一览你种过的所有植物，并获得满满的成就感。如果你还不是植树专家，请继续加油！超大的成就森林正在等着你的到来。",
  "StylizeGarden.header.closing": "挑战开始",
  "StylizeGarden.closing":
    "动动你的头脑开始照料这个新的花园吧，看看它在你的呵护下如何茁壮成长。我们迫不及待地想看到你的杰作，祝你玩得愉快！喔对了，不要忘记我们永远乐于倾听您的反馈。",
};
